import { render, staticRenderFns } from "./EditVendorLocation.vue?vue&type=template&id=5eae48b6"
import script from "./EditVendorLocation.vue?vue&type=script&lang=ts"
export * from "./EditVendorLocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports